import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Toaster } from "sonner";

// Improved ResizeObserver Error Suppression
const originalError = console.error;
console.error = (...args) => {
    if (/ResizeObserver loop completed with undelivered notifications/.test(args[0])) {
        return;
    }
    if (/ResizeObserver loop limit exceeded/.test(args[0])) {
        return;
    }
    // Suppress the specific removeChild error logging if possible, 
    // though React logs it before we catch it usually.
    if (typeof args[0] === 'string' && args[0].includes('removeChild')) {
        return; 
    }
    originalError.call(console, ...args);
};

window.addEventListener('error', (event) => {
    // Catch DOMException: Failed to execute 'removeChild' on 'Node'
    if (event.message.includes('removeChild') || event.message.includes('NotFoundError')) {
        event.stopImmediatePropagation();
        console.warn("Caught unstable DOM error. This is often caused by browser extensions.");
        // Optional: Force reload if severe
        // window.location.reload(); 
        return false;
    }

    if (event.message === 'ResizeObserver loop completed with undelivered notifications.' || 
        event.message === 'ResizeObserver loop limit exceeded') {
        
        event.stopImmediatePropagation();
        
        // Hide the webpack overlay if it appears
        const style = document.createElement('style');
        style.innerHTML = `
            #webpack-dev-server-client-overlay { display: none !important; }
            #webpack-dev-server-client-overlay-div { display: none !important; }
        `;
        document.head.appendChild(style);
        
        return false;
    }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <>
        <App />
        <Toaster richColors position="top-right" />
    </>
);
